.section {
  position: relative;
  z-index: 1;
  padding: 7rem 6vw;
}

.header {
  max-width: 680px;
  margin: 0 auto 4.5rem;
  text-align: center;
}

.eyebrow {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--teal);
  letter-spacing: 0.22em;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.heading {
  font-family: var(--font-display);
  font-size: clamp(1.9rem, 4vw, 3rem);
  font-weight: 800;
  color: var(--white);
  line-height: 1.1;
  margin-bottom: 1.1rem;
  letter-spacing: -0.02em;
}

.accent {
  color: var(--teal);
}

.sub {
  font-size: 1rem;
  color: var(--mist);
  line-height: 1.8;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;
  max-width: 1200px;
  margin: 0 auto;
}

.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 2rem 1.6rem;
  transition: border-color 0.25s, transform 0.2s, box-shadow 0.25s;
  cursor: default;
}

.card:hover {
  border-color: rgba(99, 210, 190, 0.25);
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(0,0,0,0.25);
}

.iconWrap {
  position: relative;
  width: 52px;
  height: 52px;
  margin-bottom: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.6rem;
  position: relative;
  z-index: 1;
}

.iconGlow {
  position: absolute;
  inset: 0;
  border-radius: 12px;
}

.cardTitle {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--white);
  margin-bottom: 0.65rem;
}

.cardDesc {
  font-size: 0.875rem;
  color: var(--mist);
  line-height: 1.75;
  margin-bottom: 1.25rem;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.tag {
  font-family: var(--font-mono);
  font-size: 0.66rem;
  letter-spacing: 0.08em;
  padding: 0.25rem 0.6rem;
  border-radius: 20px;
  border: 1px solid;
  font-weight: 500;
}

@media (max-width: 1100px) {
  .grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 560px) {
  .section { padding: 5rem 5vw; }
  .grid { grid-template-columns: 1fr; }
}
